import { useContext, useState } from 'react';
import './index.css';
import { filterDataContext } from '../../App';
import { REMOVE_RESERVATION_API } from '../../APIs';

const PriceIncreasePopUp = ({ cartData, setState }) => {
    const { fetchCartList } = useContext(filterDataContext);

    const handleDeleteReservationTicket = async (id) => {
        try {
            const payload = { ticket_id: id };
            const response = await REMOVE_RESERVATION_API(payload);
            if (response && response?.status) {
                fetchCartList();
            }
        } catch (error) {
            console.log(error, "RESERVATION_DELETE_API");
        }
    };

    return (

        <div className="popup-container">
            <div className="popup-content">
                {Object.entries(cartData).map(([eventName, tickets]) => (
                    <div key={eventName} className="event-section">
                        <h2 className="event-name">{eventName}</h2>
                        {tickets.map((ticket) => {
                            const { priceNotification, id, ticket_id, ticket_title, net_rate_inr, face_value_inr, event_event } = ticket;
                            const { isIncressPrice, isDecressPrice, incresssPrice, decressPrice, oldPrice, newPrice } = priceNotification || {};

                            return (
                                <div className="ticket-card" key={id}>
                                    <div className="ticket-header">
                                        <h3>{ticket_title}</h3>
                                        <p><strong>Venue:</strong> {event_event?.venue?.official_name}</p>
                                    </div>

                                    {priceNotification && (
                                        <>
                                            <p className="price-message">
                                                {isIncressPrice
                                                    ? "The ticket price has increased!"
                                                    : isDecressPrice
                                                        ? "The ticket price has decreased!"
                                                        : "The ticket price has changed!"}
                                            </p>

                                            <div className="price-info">
                                                <span className="old-price">₹{oldPrice?.toLocaleString()}</span>
                                                <span className="new-price">₹{newPrice?.toLocaleString()}</span>
                                            </div>
                                        </>
                                    )}

                                    <button
                                        className="remove-btn"
                                        onClick={() => handleDeleteReservationTicket(ticket_id)}
                                    >
                                        Remove
                                    </button>
                                </div>
                            );
                        })}
                    </div>
                ))}
            </div>

            <div className="button-container">
                <button
                    className="continue-btn"
                    onClick={() => setState(false)}
                >
                    Continue
                </button>
            </div>
        </div>

    );
};

export default PriceIncreasePopUp;
